export default {
    title: 'O céu no momento',
    subTitle: '<strong>{day}</strong>, {date}',
    description: '<p>A todo instante, os astros estão em movimento, transitando em diferentes velocidades enquanto passam por diversos locais da abóbada celeste. Cada planeta passa 30 graus em cada signo e são estes trânsitos que dão corpo a toda dinâmica astrológica.</p> <p>Este quadro exibe o posicionamento dos astros neste exato momento, seus aspectos de interação uns com os outros e a atual fase da lua no GMT -3.</p>',
    activeAspects: 'Aspectos ativos',
    orb: 'Orbe',
    errorMessage: 'Não foi possível carregar as informações do céu no momento'
}